export default {
  "menu": "_menu_1i0lo_1",
  "section": "_section_1i0lo_1",
  "item": "_item_1i0lo_1",
  "arrow": "_arrow_1i0lo_1"
};import "ni:sha-256;8Wg5_3itOUSmSRN2ZjddC5negS-SbYMuuUCBYWMyiCA";